"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpointageCommentMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class EpointageCommentMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isLoading = lodash_1.default.get(result, "loading");
        const epointageComment = lodash_1.default.get(result, "data.addEPointageComment");
        return {
            hasError,
            isLoading,
            epointageComment,
        };
    }
}
exports.EpointageCommentMapper = EpointageCommentMapper;
